import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import { BaseRequestComponent }                from '../../baseclasses/BaseRequest.component';
import {UserInfoComponent} from '../../components/ControlGroups/UserInfo.component';
import {CompletionDetailsComponent} from '../../components/ControlGroups/CompletionDetails.component';
import {GeneralDetailsComponent} from '../../components/ControlGroups/GeneralDetails.component';
import {AddressComponent} from '../../components/ControlGroups/Address.component';
import {NotesComponent} from '../../components/ControlGroups/Notes.component';
import {RequestHeaderComponent} from '../../components/Controls/RequestHeader.component';
import {ChangePhoneNumberDialogComponent} from '../../components/Employees/ChangePhoneNumberDialog.component';
import { SalesAndDeliveryDetailsComponent } from '../ControlGroups/SalesAndDeliveryDetails.component';

@Component({
  selector: 'my-createpartnerfunctions-request',
  templateUrl: './CreatePartnerFunctionsRequest.component.html'
})
export class CreatePartnerFunctionsRequestComponent extends BaseRequestComponent {

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;

    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(GeneralDetailsComponent) generalDetailsComponent: GeneralDetailsComponent;
    @ViewChild(SalesAndDeliveryDetailsComponent) salesAndDeliveryDetailsComponent: SalesAndDeliveryDetailsComponent;
    @ViewChild(AddressComponent) addressComponent: AddressComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;

    constructor(private customerService: serv.CustomerService, private employeeService: serv.EmployeeService) 
    {
        super();
    }


    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus())
        {
              this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
    }

    customerNumberChanged(event: string) {
        var request: ent.CustomerDetailsRequest = {customerNumber: event};
        this.customerService.getCustomerDetails(request).subscribe(x => {
            var zjPartners = x.salesArea.partner.filter(x=>x.type == "ZJ");
            if (zjPartners.length == 1){
                var zjPartner = zjPartners[0].number.replace(/^0+/, '');
                this.employeeService.getEmployees({EmployeeNameOrPersonnelNumberLike: zjPartner}).subscribe(y=> {
                    if (y.length == 1) {
                        this.salesAndDeliveryDetailsComponent.existingZJPartnerEmployee = y[0].FullNameWithPersonnelNumber;    
                    }
                })
            }

            var znPartners = x.salesArea.partner.filter(x=>x.type == "ZN");
            if (znPartners.length == 1){
                var znPartner = znPartners[0].number.replace(/^0+/, '');
                this.employeeService.getEmployees({EmployeeNameOrPersonnelNumberLike: znPartner}).subscribe(y=> {
                    if (y.length == 1) {
                        this.salesAndDeliveryDetailsComponent.existingZNPartnerEmployee = y[0].FullNameWithPersonnelNumber;    
                    }
                })
            }
        });
    }

    onSaveClick(event: any){
        
        this.requestToSave = {
            ID: this.requestID,
            RequestTypeID: enums.RequestTypeEnum.PartnerFunctions,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            GeneralInfo: this.generalDetailsComponent.generalInfo,
            SalesAndDeliveryInfo: this.salesAndDeliveryDetailsComponent.salesAndDeliveryInfo,
            //OtherInfo: this.notesComponent.otherInfo,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID, 
            SalesOfficeID: this.userInfoComponent.userInfo.SalesOffice.ID, 
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };

        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);
        
        if (this.userInfoComponent.request.PhoneNumber){
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }
        this.requestToSave.Addresses = [];

        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);
    }
    onYes(event: ent.Response){
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any){
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any){
        //do nothing
    }

    onSubmitClick(event: any){
        this.getRequest(true);
    }


}